module.exports = __webpack_public_path__ + "static/img/海信（Hisense） U8N Pro.02f8ad89.png";